import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Hurricane.svg",
  "use": "Hurricane.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Hurricane.svg\"><path d=\"M52,34c0,13.3553-13.3491,24-31,24a1,1,0,0,1-1-1,1.1057,1.1057,0,0,1,.7786-1.0764A4.008,4.008,0,0,0,24,52c0-5.4385-12-9.3249-12-22C12,16.6447,25.3491,6,43,6a1,1,0,0,1,1,1,1.1056,1.1056,0,0,1-.7784,1.0763A4.0083,4.0083,0,0,0,40,12C40,17.4385,52,21.3249,52,34ZM32,24a8,8,0,1,0,8,8A8,8,0,0,0,32,24Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol